import { columnTypes, dataTypes, Table } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styles from '../styles.module.scss';
import { getItemsNotAddedCustomRenders } from '../utils';

const CartImportSummaryItemsNotAdded = ({ itemsNotAdd }) => {
  const { t } = useTranslation();
  const itemsNotAddKeys = itemsNotAdd?.map((item, index) => ({
    ...item,
    reactKey: index
  }));
  const schema = [
    {
      id: 'partQuantity',
      label: t('QUANTITY1'),
      hideOnMobile: true,
      dataType: dataTypes.ALPHANUMERIC,
      columnType: columnTypes.STRETCHED
    },
    {
      id: 'partNumber',
      label: t('NUMBER'),
      hideOnMobile: true,
      dataType: dataTypes.ALPHANUMERIC,
      columnType: columnTypes.STRETCHED
    },
    {
      id: 'error',
      label: t('ERROR'),
      hideOnMobile: true,
      dataType: dataTypes.ALPHANUMERIC,
      columnType: columnTypes.STRETCHED
    },
    {
      id: 'itemsNotAddedMobileCell',
      width: '90%',
      partQuantityLabel: t('QUANTITY1'),
      partNumberLabel: t('NUMBER'),
      errorLabel: t('ERROR'),
      hideOnDesktop: true,
      dataType: dataTypes.NUMBER,
      columnType: columnTypes.STRETCHED
    }
  ];

  return (
    <div className="mb-4">
      <h3 className="text-uppercase ps-1">{t('ITEMS_NOT_ADDED')}</h3>
      <p className={`${styles['cart-import-summary__text']} mb-3 mt-3`}>
        {t('ITEMS_NOT_ADDED_MESSAGE')}
      </p>
      <Table
        schema={schema}
        data={itemsNotAddKeys}
        customRenderers={getItemsNotAddedCustomRenders()}
      />
    </div>
  );
};

export default CartImportSummaryItemsNotAdded;

CartImportSummaryItemsNotAdded.propTypes = {
  itemsNotAdd: PropTypes.arrayOf(
    PropTypes.shape({
      partQuantity: PropTypes.string,
      error: PropTypes.string,
      partNumber: PropTypes.string
    })
  )
};
